import React from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ 
  onGenerate,
  onClear, 
  disabled
}) => {
  return (
    <div className="space-y-3">
      <Button
        variant="default"
        onClick={onGenerate}
        iconName="Sparkles"
        iconPosition="left"
        fullWidth
        size="lg"
      >
        Generate Prompt
      </Button>
      
      <Button
        variant="outline"
        onClick={onClear}
        iconName="RotateCcw"
        iconPosition="left"
        fullWidth
      >
        Clear Form
      </Button>
    </div>
  );
};

export default ActionButtons;